import { getGeoJsonPropertyNumber, getGeoJsonPropertyText, setGeoJsonProperty } from "shared/map/domain/geojson";

export function geoJsonStyle(feature: GeoJSON.Feature) {

  return {
    get color() {
      return getColor(feature);
    },

    set color(value: string | undefined) {
      if (!value) {
        value = '#a7f3d0';
      }
      setColor(feature, value);
    },

    get outlineColor() {
      return getOutlineColor(feature);
    },

    set outlineColor(value: string | undefined) {
      if (!value) {
        value = '#000000';
      }
      setOutlineColor(feature, value);
    },

    get outlineSize() {
      return getOutlineSize(feature);
    },

    set outlineSize(value: number | undefined) {
      if (!value) {
        value = 1;
      }
      setOutlineSize(feature, value);
    }
  }
}

const colorKey = 'color';

export function getColor(feature: GeoJSON.Feature) {
  return getGeoJsonPropertyText(feature, colorKey);
}

export function setColor(feature: GeoJSON.Feature, color: string) {
  setGeoJsonProperty(feature, colorKey, color);
}

export function defaultColor(feature: GeoJSON.Feature, defaultColor: string) {
  const color = getColor(feature);
  if (!color) {
    setColor(feature, defaultColor);
  }
}

const outlineColorKey = 'outlineColor';

export function getOutlineColor(feature: GeoJSON.Feature) {
  return getGeoJsonPropertyText(feature, outlineColorKey);
}

export function setOutlineColor(feature: GeoJSON.Feature, color: string) {
  setGeoJsonProperty(feature, outlineColorKey, color);
}

const outlineSizeKey = 'outlineSize';

export function getOutlineSize(feature: GeoJSON.Feature) {
  return getGeoJsonPropertyNumber(feature, outlineSizeKey);
}

export function setOutlineSize(feature: GeoJSON.Feature, size: number) {
  setGeoJsonProperty(feature, outlineSizeKey, size);
}

export function defaultOutlineColor(feature: GeoJSON.Feature, defaultColor: string) {
  const outlinecolor = getOutlineColor(feature);
  if (!outlinecolor) {
    setOutlineColor(feature, defaultColor);
  }
}

export function defaultOutlineSize(feature: GeoJSON.Feature, defaultColor: number) {
  const outlinecolor = getOutlineColor(feature);
  if (!outlinecolor) {
    setOutlineSize(feature, defaultColor);
  }
}
